import { useContext } from 'react';
import { ErrorMonitorContext } from './ErrorMonitorProvider';
export const useErrorMonitor = () => {
    const errorMonitor = useContext(ErrorMonitorContext);
    if (!errorMonitor) {
        throw new Error('useErrorMonitor() cannot be used without an <ErrorMonitorProvider>');
    }
    return errorMonitor;
};
//# sourceMappingURL=useErrorMonitor.js.map